export const appVersion: string = 'v.5.1.2';
